import React, { memo } from 'react'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { CheckOutlineIcon, WarningFilledIcon, NotAvailableIcon } from 'transfix-icons'

export const STATUSES = {
  SATISFACTORY: {
    text: 'Satisfactory',
    IconComponent: CheckOutlineIcon,
    color: brandColors.info,
  },
  CONDITIONAL: {
    text: 'Conditional',
    IconComponent: WarningFilledIcon,
    color: brandColors.info,
  },
  'NOT RATED': {
    text: 'Not Rated',
    IconComponent: CheckOutlineIcon,
    color: brandColors.coolGray5,
  },
  UNSATISFACTORY: {
    text: 'Unsatisfactory',
    IconComponent: NotAvailableIcon,
    color: brandColors.error,
  },
}

interface IFMCSARatingProps {
  status?: keyof typeof STATUSES
}

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(0.5),
  },
}))

export const FMCSARating = memo<IFMCSARatingProps>(({ status = 'NOT RATED' }) => {
  const classes = useStyles()

  let currentStatus = STATUSES[status]

  if (!currentStatus) {
    currentStatus = STATUSES['NOT RATED']
  }

  const { IconComponent, color, text } = currentStatus

  return (
    <Box display='flex' alignItems='center' color={color}>
      <IconComponent className={classes.icon} size='medium' />
      <Typography component='div' variant='body2'>
        {text}
      </Typography>
    </Box>
  )
})
